var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRightBrandGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.119 6.81928L8.315 11.5823L6.964 13.0563L0.159 6.81928L6.964 0.582275L8.315 2.05628L3.119 6.81928Z",
    fill: "#94BE43"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBrandGreen);
export default __webpack_public_path__ + "static/media/ChevronRightBrandGreen.834ef7dee904e8e8defa7787d3e7593e.svg";
export { ForwardRef as ReactComponent };